module.exports = __webpack_public_path__ + "static/media/proxima-nova-webfont.57e17dba.woff";